import React from "react"
import usePlatform from "contexts/platform/use-platform"
import { Answers } from "components"
import { useQuery } from "react-query"

interface IAnswersProps {
  policyId: string
}

export const PolicyAnswers: React.FC<IAnswersProps> = (props) => {
  const platform = usePlatform()
  const answers = useQuery(["policy", "answers", props.policyId], () =>
    platform.policy.getAnswers(props.policyId)
  )

  return (
    <Answers
      data={answers.data}
      isLoading={answers.isLoading}
      isError={answers.isError}
    />
  )
}
